import LoginIsland from "../ts/components/user/LoginIsland";
export default async function onLogin(ctx) {
    void ctx;
    await mountLoginIsland();
}
async function mountLoginIsland() {
    const loginContainer = document.getElementById('login-providers-root');
    if (loginContainer) {
        try {
            const { createRoot } = await import('react-dom/client');
            const React = await import('react');
            const root = createRoot(loginContainer);
            root.render(React.createElement(LoginIsland));
        }
        catch (error) {
            console.error('Failed to mount login island:', error);
        }
    }
}
